module.exports = __webpack_public_path__ + "static/img/dui.cdd7651.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dui.png
// module id = ovJ0
// module chunks = 1